import type { ReactNode, RefObject } from 'react';

import Slide from '@mui/material/Slide';

import { Box } from '../../../Box';
import { Button } from '../../../Button';
import { Icon } from '../../../Icon';
import { Link } from '../../../Link';
import { Tooltip } from '../../../Tooltip';
import useStyles from '../FileInput.styles';

interface FileInputPreviewActionsProps {
  children: ReactNode;
  isDesktop: boolean;
  blobDocument: RefObject<Blob | null>;
  allowedTypes: string[];
  isButtonsVisible: boolean;
  disabled?: boolean;
  testId: string;
  onRemove: () => void;
  onRotate: () => void;
}

export const FileInputPreviewActions = ({
  children,
  isDesktop,
  blobDocument,
  allowedTypes,
  isButtonsVisible,
  disabled,
  testId,
  onRemove,
  onRotate,
}: FileInputPreviewActionsProps) => {
  const { classes } = useStyles();

  return (
    <>
      <Box position="relative" width="100%" height="100%">
        {children}
        {!isDesktop && !disabled && (
          <Box position="absolute" top={7} right={8} zIndex={1}>
            <Button
              size="extraSmall"
              variant="quaternaryAccent"
              onClick={onRemove}
              testId={`${testId}-clear`}
              icon={
                <Icon name="cancel" size="16" color="original.brand.primary" />
              }
            />
          </Box>
        )}
      </Box>
      {isDesktop && (
        <Slide
          direction="up"
          in={isButtonsVisible}
          mountOnEnter
          unmountOnExit
          timeout={500}
        >
          <div className={classes.previewButtons}>
            <Box>
              {blobDocument?.current?.type.startsWith('image/') && (
                <Tooltip
                  title="Повернуть изображение против часовой стрелки"
                  placement="bottom"
                >
                  <div>
                    <Link
                      size="medium"
                      onClick={onRotate}
                      testId={`${testId}-rotate`}
                      startIcon={
                        <Icon
                          name="rotate_left"
                          size="16"
                          color="original.brand.primary"
                        />
                      }
                      stroke={false}
                    />
                  </div>
                </Tooltip>
              )}
            </Box>
            {!disabled && (
              <Link
                size="small"
                onClick={onRemove}
                testId={`${testId}-clear`}
                endIcon={
                  <Icon
                    name="delete_outline"
                    size="16"
                    color="original.brand.primary"
                  />
                }
                stroke={false}
              >
                Удалить
              </Link>
            )}
          </div>
        </Slide>
      )}
      {!isDesktop &&
        allowedTypes.includes(blobDocument?.current?.type || '') && (
          <Box position="absolute" right={16} bottom={16}>
            <Button
              variant="quaternary"
              testId={`${testId}-rotate`}
              icon={
                <Icon
                  name="rotate_left_outline"
                  size="16"
                  color="original.brand.primary"
                />
              }
              onClick={onRotate}
            />
          </Box>
        )}
    </>
  );
};
